<template>
  <b-form @submit.prevent="$emit('ok', { messageBody })">
    <b-form-group label="Message to patient">
      <b-textarea v-model="messageBody" />
    </b-form-group>
    <portal to="task-modal-footer">
      <div slot-scope="{ cancel, ok }">
        <b-button class="m-1" type="button" variant="secondary" @click="cancel()">Cancel</b-button>
        <b-button
          class="m-1"
          type="button"
          variant="primary"
          @click="
            $emit('input', { messageBody })
            ok()
          "
          >Send message</b-button
        >
      </div>
    </portal>
  </b-form>
</template>

<script>
export default {
  data() {
    return {
      messageBody: '',
    }
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
  },
}
</script>
